export default "/assets/images/mama-room4.977bc9c47c0f4534.png";